import { render, staticRenderFns } from "./ChartBoard.vue?vue&type=template&id=caff8da2&scoped=true&"
import script from "./ChartBoard.vue?vue&type=script&lang=js&"
export * from "./ChartBoard.vue?vue&type=script&lang=js&"
import style0 from "./ChartBoard.vue?vue&type=style&index=0&id=caff8da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caff8da2",
  null
  
)

export default component.exports